import React, { useEffect, useState } from 'react';

import EditVisibilityPopUpView from './view';


import * as EmailServices from '@services/EmailTemplate';

import { decryptText } from '@library/enc-dec';

function EditVisibilityPopUp(props) {
	const [error, setError] = useState('');
	const [visibility, setVisibility] = useState(false)

	useEffect(()=>{
		setVisibility(props.template.status)
	},[props])

	const handleCloseBtn = () => {
		props.handleClose()
	};

	const handleSaveBtn = async () => {
		if (false) {
			setError('Number is incorrect');
			setTimeout(function () {
				setError('');
			}, 2000);
		} else {

			if(visibility)
			{
				const payload = {
					templateId: props.template._id,
					status: visibility, // active => disabled
					scenario : props.template.scenario
				}
				let authToken = decryptText(localStorage.getItem('aEmediat'));
				// var isSaved = await props.handleSave(selectedSeriesList);
				const response = await EmailServices.updateEmailTemplateStatus(payload, authToken);
				
				if (response.success) {
					props.handleSave(response)
				}
				alert(response.message);	
			}
			
		}
	};

	return (
		<EditVisibilityPopUpView
				error={error}
				visibility={visibility}
				setVisibility={setVisibility}
				handleCloseBtn={handleCloseBtn}
				handleSaveBtn={handleSaveBtn}
			/>
	);
}

export default EditVisibilityPopUp;
